import { render, staticRenderFns } from "./AddConsumption.vue?vue&type=template&id=372c2cce&"
import script from "./AddConsumption.vue?vue&type=script&lang=js&"
export * from "./AddConsumption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports